module.exports = __webpack_public_path__ + "img/excrement_bags.c2099f7a.svg";